import { createSlice, type PayloadAction } from '@reduxjs/toolkit'

export interface CreateCustomDevice {
  deviceTemplateId: string
  message: string
}

export interface UploadFileInfoState {
  isLoading: boolean
  loadingError: string | null
  CreateCustomDevice: CreateCustomDevice | null
  httpStatus: number | null
}

export const initialState: UploadFileInfoState = {
  isLoading: false,
  CreateCustomDevice: null,
  loadingError: null,
  httpStatus: null
}

export const createCustomDeviceInfoSlice = createSlice({
  name: 'customDeviceInfoSlice',
  initialState,
  reducers: {
    resetCustomDeviceUpload: () => {
      return {
        isLoading: false,
        CreateCustomDevice: null,
        loadingError: null,
        httpStatus: null
      }
    },
    uploadCustomDeviceFileInfoDataLoading: (state): UploadFileInfoState => {
      return {
        isLoading: false,
        CreateCustomDevice: null,
        loadingError: null,
        httpStatus: 0
      }
    },
    uploadCustomDeviceFileInfoDataError: (state, action: PayloadAction<{ errorMessage: string, httpStatus: number }>): UploadFileInfoState => {
      return {
        isLoading: false,
        loadingError: action.payload.errorMessage,
        CreateCustomDevice: null,
        httpStatus: action.payload.httpStatus
      }
    },
    uploadCustomDeviceFileInfoData: (state, action: PayloadAction<{ data: CreateCustomDevice, httpStatus: number }>): UploadFileInfoState => {
      return {
        isLoading: false,
        loadingError: null,
        CreateCustomDevice: action.payload.data,
        httpStatus: action.payload.httpStatus
      }
    }
  }
})

export const { uploadCustomDeviceFileInfoDataLoading, uploadCustomDeviceFileInfoDataError, uploadCustomDeviceFileInfoData, resetCustomDeviceUpload } = createCustomDeviceInfoSlice.actions
export default createCustomDeviceInfoSlice.reducer
